export const emptyPhenotypeResponse = {
    associations: {},
    category_id: '',
    category_name: '',
    category_short_name: '',
    phenotype_id: '',
    phenotype_name: '',
    traits_type: undefined,
};
